import React, { useEffect } from 'react'
import { PageHeading } from 'app/layout/PageHeading'
import { useAnalytics } from 'app/shared/hooks/useAnalytics'
import { InfoLineItem, InfoPageSection } from 'app/layout/InfoPageSection'
import { WhatIsSwingDancingPanel } from '../components/Home/WhatIsSwingDancingPanel'

const exampleVideos = [
  {
    name: 'Medium Tempo Lindy Hop',
    description:
      "Lindy Hop is the primary form of dance that we teach at STL Swing.  It's fast, fun, and high energy.  This is an example done to medium tempo music.",
    link: 'https://www.youtube.com/watch?v=BWt4_KpYLgM',
  },
  {
    name: 'Lindy Hop Battle Competition',
    description:
      'Part of Lindy Hop culture is competition.  One of the primary forms of Lindy Hop competition is the battle, where judges watch multiple dancers at the same time.',
    link: 'https://www.youtube.com/watch?v=pGtjSt7u_20',
  },
  {
    name: 'Fast Lindy Hop',
    description:
      "Lindy Hop is the primary form of dance that we teach at STL Swing.  It's fast, fun, and high energy.",
    link: 'https://www.youtube.com/watch?v=v9xxeWRxSbA',
  },
  {
    name: 'Slow Swing',
    description: 'A form of swing dance done to slower music.',
    link: 'https://www.youtube.com/watch?v=xYtf5Tfdi_w',
  },
  {
    name: 'Solo Jazz',
    description: 'A form of swing that is danced solo.',
    link: 'https://www.youtube.com/watch?v=D1gQ_gjNUtk&list=PL9NYzfVwgE2edYYV3LouvNUqhY12cz9Uh&index=66',
  },
  {
    name: 'Balboa',
    description: 'A form of dance that is done in close embrace to fast music.',
    link: 'https://www.youtube.com/watch?v=hU4gsbyYJLY',
  },
]

export const WhatItLooksLikePanel = ({ className }: C) => (
  <InfoPageSection
    className={`bg-paper ${className || ''}`}
    title='What does it look like?'>
    {exampleVideos.map((video) => (
      <InfoLineItem
        key={video.name}
        title={video.name}
        description={video.description}
        href={video.link}
        linkText='Watch video'
      />
    ))}
  </InfoPageSection>
)

export const AboutPage = () => {
  const { pageViewEvent } = useAnalytics()

  useEffect(() => {
    pageViewEvent('About')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <section className='relative z-0 min-h-screen bg-white'>
      <PageHeading title='About' image='stlswing/wednesday-night-swing.jpg' position='50% 25%' />

      <WhatIsSwingDancingPanel />

      <WhatItLooksLikePanel />
    </section>
  )
}

export default AboutPage
